module.exports = __webpack_public_path__ + "img/logo.4dd42fb4.svg";